import { useMediaQuery } from "@mui/material";
export const useScreenSize = () => {
    const isDesktop = useMediaQuery("(min-width: 768px)");
    if (isDesktop) {
        return "desktop";
    }
    else {
        return "mobile";
    }
};
